import { EXTERNAL_PUBLISHED_COUNT_LOADED, ExternalPublishedCountLoadedAction, ExternalPublishedCountItem } from '../../actions/pagedListings/load-external-published-count';

export default (state: ExternalPublishedCountItem[] = [], action: ExternalPublishedCountLoadedAction) => {
    switch (action.type) {
        case EXTERNAL_PUBLISHED_COUNT_LOADED:
            return [...action.payload];
        default:
            return state;
    }
};